import { ContactUserTokenFilterParams } from '../../models/contact_notification_token';

const testMessageSettingUserKeys = {
    singleTestMessageUser: ['single_test_message_users'],
    groupTestMessageUser: ['group_test_message_users'],
    existingGroupTestMessageUser: (provider_id: string) => [
        'existing_test_message_users',
        provider_id,
    ],
    filteredSingleTestMessageUser: (
        filterParams?: ContactUserTokenFilterParams,
    ) => [
        testMessageSettingUserKeys.singleTestMessageUser,
        filterParams?.push_provider_id,
    ],
};

export default testMessageSettingUserKeys;
